// Plan-shopping requests typed into ordinary Ask chat route into the plan finder (one coherent entry).
const SHOP = [
  /\b(top\s*(3|three)|best|choose|pick|recommend|find|shop(ping)?\s*for|switch\s+to|compare|looking\s+for|help\s+me\s+(choose|pick|find))\b[^.?!]{0,60}\b(medicare\s+advantage|advantage\s+plans?|plans?)\b/i,
  /\bwhich\s+plans?\b/i,
  /\bgood\s+plans?\s+for\b/i,
  /\bplans?\s+(in|near|for)\s+(zip\s*)?\d{5}\b/i,
  /\bneed\s+a\s+(new|better|different)\s+plan\b/i,
];
const NOT = /\b(medigap|supplement|plan\s+[a-n]\b|part\s+d\s+only|dentist|find\s+out|what\s+(does\s+)?my\s+plan\s+covers?|when\s+(can|do)\s+i|time\s+to\s+enroll|enrollment\s+period)\b/i;

export const isPlanShopping = (t) => !!t && !NOT.test(t) && SHOP.some((r) => r.test(t));
